import axios from 'axios';

// URL fixa da API
const API_URL = process.env.REACT_APP_API_URL || 'https://api.jtracking.app/api';

console.log('API URL:', API_URL); // Debug

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 60000
});

api.interceptors.request.use((config) => {
  console.log('Request:', config.method, config.url); // Debug
  const token = localStorage.getItem('jtracker_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.log('Response OK:', response.status); // Debug
    return response;
  },
  (error) => {
    console.error('Response Error:', error.message); // Debug
    if (error.response?.status === 401) {
      localStorage.removeItem('jtracker_token');
      localStorage.removeItem('jtracker_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const login = (email, password) => api.post('/auth/login', { email, password });
export const getMe = () => api.get('/auth/me');
export const updateProfile = (data) => api.put('/auth/profile', data);
export const listUsers = () => api.get('/auth/users');
export const createUser = (data) => api.post('/auth/users', data);
export const updateUser = (id, data) => api.put('/auth/users/' + id, data);
export const deleteUser = (id) => api.delete('/auth/users/' + id);
export const getDashboard = (period) => api.get('/dashboard?period=' + (period || 'last_7d'));
export const getSummary = (period) => api.get('/dashboard/summary?period=' + (period || 'today'));
export const getSales = (params) => api.get('/sales', { params: params || {} });
export const getSaleById = (id) => api.get('/sales/' + id);
export const getSalesStats = (params) => api.get('/sales/stats', { params: params || {} });
export const reprocessSale = (id) => api.post('/sales/' + id + '/reprocess');
export const exportSales = (params) => api.get('/sales/export', { params: params || {} });
export const getCampaigns = () => api.get('/campaigns');
export const getCampaignInsights = (period) => api.get('/campaigns/insights?period=' + (period || 'last_7d'));
export const testMetaConnection = () => api.get('/campaigns/test/meta');
export const testCapiConnection = () => api.get('/campaigns/test/capi');
export const testDataCrazyConnection = () => api.get('/campaigns/test/datacrazy');
export const getConfig = () => api.get('/config');
export const updateConfig = (data) => api.put('/config', data);
export const getWebhookInfo = () => api.get('/config/webhook');
export const regenerateWebhookSecret = () => api.post('/config/webhook/regenerate');
export const getWebhookLogs = (params) => api.get('/webhook/logs', { params: params || {} });

export default api;

// Meta CAPI Logs
export const getCapiLogs = (params) => api.get('/capi-logs', { params: params || {} });
export const getCapiLogsStats = () => api.get('/capi-logs/stats');
export const getCapiLogsByPhone = (phone) => api.get('/capi-logs/by-phone/' + phone);
export const getCapiLogById = (id) => api.get('/capi-logs/' + id);

// Ad Accounts
export const discoverAdAccounts = () => api.get('/ad-accounts/discover');
export const syncAdAccounts = (accounts) => api.post('/ad-accounts/sync', { accounts });
export const getAdAccounts = () => api.get('/ad-accounts');
export const addAdAccount = (data) => api.post('/ad-accounts', data);
export const updateAdAccount = (id, data) => api.put('/ad-accounts/' + id, data);
export const toggleAdAccount = (id) => api.post('/ad-accounts/' + id + '/toggle');
export const deleteAdAccount = (id) => api.delete('/ad-accounts/' + id);
export const selectAllAdAccounts = (selected) => api.post('/ad-accounts/select-all', { selected });

// Business Managers
export const listBusinessManagers = () => api.get('/business-managers');
export const addBusinessManager = (data) => api.post('/business-managers', data);
export const discoverBMAccounts = (id) => api.post('/business-managers/' + id + '/discover');
export const discoverAllBMAccounts = () => api.post('/business-managers/discover-all');
export const toggleBusinessManager = (id) => api.put('/business-managers/' + id + '/toggle');
export const deleteBusinessManager = (id) => api.delete('/business-managers/' + id);

// Webhook Analytics
export const getWebhookAnalytics = (period) => api.get('/dashboard/webhook-analytics', { params: { period } });

// Sellers (Gestão Comercial)
export const listSellers = () => api.get('/sellers');
export const createSeller = (data) => api.post('/sellers', data);
export const updateSeller = (id, data) => api.put('/sellers/' + id, data);
export const deleteSeller = (id) => api.delete('/sellers/' + id);
export const getSellerMetrics = (days) => api.get('/sellers/metrics', { params: { days } });

// Roles (Cargos e Permissões)
export const listRoles = () => api.get('/roles');
export const createRole = (data) => api.post('/roles', data);
export const updateRole = (id, data) => api.put('/roles/' + id, data);
export const deleteRole = (id) => api.delete('/roles/' + id);
export const assignRole = (userId, roleId) => api.post('/roles/assign', { userId, roleId });

// Plans
export const getPlans = () => api.get('/plans');
export const getMySubscription = () => api.get('/plans/my-subscription');
export const getPlanUsage = () => api.get('/plans/usage');

export const renameBM = (id, name) => api.put('/business-managers/' + id + '/rename', { name });
